import { Switch } from "antd";
import React, { useEffect } from "react";
import { autoRefresh, switchAutoFresh } from "../../redux/EngageTranslation/EngageTranslationAction";
import { SyncOutlined } from "@ant-design/icons";
import { useAppDispatch } from "../../redux/useAppDispatch";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";

function AutoRefreshCheckbox(props: any) {
  const dispatch = useAppDispatch();
  const autoRefreshState = useSelector((state: RootState) => state.engageTranslationState.autoRefreshState);
  useEffect(() => {
    dispatch(autoRefresh({ view: props.view || "new" }));
  }, [autoRefreshState.autoRefresh]);
  return (
    <div className="auto-refresh-checkbox h-100 ">
      <SyncOutlined
        style={{ fontSize: 15, visibility: autoRefreshState.loading ? "visible" : "hidden" }}
        spin
      />
      <Switch
        size="default"
        defaultChecked={autoRefreshState.autoRefresh}
        onChange={(checked) => {
          dispatch(switchAutoFresh({ autoRefresh: checked }));
        }}
      />

      <span>Auto Refresh</span>
    </div>
  );
}

export default AutoRefreshCheckbox;
